import React from 'react';

import { Page } from 'components/layouts';
import Connection from 'components/connection';

import AboutInfo from './about-info';
import AboutServices from './about-services';
import BuyNow from './buy-now';

import './style.css';

const start01 = {
  query: '#about-info-start-circuit',
  pivot: { x: 0.5, y: 1 },
};

const About = () => {
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <Page className="page -about">
      <Connection
        A={start01}
        B={{
          query: '#about-info-end-circuit',
        }}
      />
      <Connection
        A={start01}
        B={{
          query: '.services-icons li:first-child svg',
          pivot: { x: 0.5, y: 0.5 },
        }}
      />
      <Connection
        A={{
          query: 'section.services .rich-text p:last-of-type',
          pivot: { x: 0.5, y: 1 },
        }}
        B={{ query: 'section.services .target' }}
        duration={5}
        curve={0.4}
      />
      <AboutInfo />
      <AboutServices />
      <BuyNow />
    </Page>
  );
};

export default About;
